var $83cb840505d0a125$exports = {};
$83cb840505d0a125$exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`
};


export {$83cb840505d0a125$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
